export enum DiscoveryPropertySettingState {
    Disabled = 0,
    Preview = 1,
    Published = 2
}
